import React from 'react';
import { useAtomValue } from 'jotai';
import {
  isExpiredAtom,
  planDetailAtom,
  subjectSubscriptionAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import MiniOverview from '@components/subscription/overview/micro/MiniOverview';

const TrialPlanCardDescription = () => {
  const subscription = useAtomValue(subjectSubscriptionAtom);
  const planDetail = useAtomValue(planDetailAtom);
  const isExpired = useAtomValue(isExpiredAtom);

  if (!subscription || !planDetail) {
    return null;
  }

  return (
    <div
      className={
        'p-4 rounded-2xl text-neutral-chalk ' +
        (isExpired ? 'bg-neutral-graphite' : 'bg-primary-navyblue-shade')
      }
      data-testid={'card'}
    >
      <MiniOverview
        subscription={subscription}
        planDetail={planDetail}
        isExpired={isExpired}
      />
    </div>
  );
};

export default TrialPlanCardDescription;
